<template>
    <div class="search-listing width-100%">
        <div class="grid__wrapper">
            <!-- @slot Content before looped items -->
            <slot name="before"></slot>

            <template v-for="(item, i) in items">
                <div
                    :key="`${_uid}-${item.submodelId}-${i}`"
                    v-bind="itemWrapperAttrs"
                    :style="{ order: i }"
                    class="search-listing__item width-100%"
                >
                    <!-- @slot Content for the listing item. Fallback content: `VehicleCard` component -->
                    <slot name="item" v-bind="{ item }">
                        <vehicle-card :item="item" v-bind="itemProps" />
                    </slot>
                    <stock-aggregator-banner
                        v-if="showStockAggregatorBanner && (i === 2 || i === 11)"
                        v-bind="stockAggregatorBannerData"
                        class="m-top--m"
                        @click="e => onBannerClick(e, i + 1)"
                    />
                </div>
            </template>
        </div>
    </div>
</template>

<script>
import isEmpty from 'lodash/isEmpty';
/**
 * A component for showing searched items
 *
 * @version 4.0.0
 * @example ./examples/SearchListing.md
 */
export default {
    name: 'SearchListing',
    components: {
        VehicleCard: () => ({
            component: import(/* webpackChunkName: "VehicleCard-vue" */ '@v4/common/components/molecules/VehicleCard'),
        }),
        StockAggregatorBanner: () => ({
            component: import(
                /* webpackChunkName: "StockAggregatorBanner-vue" */ '@v4/stock-aggregator/components/molecules/StockAggregatorBanner/StockAggregatorBanner.vue'
            ),
        }),
    },
    props: {
        /**
         * Items to loop through
         */
        items: {
            type: Array,
            default: () => [],
        },
        /**
         * Attribues on listing item wrapper
         */
        itemWrapperAttrs: {
            type: Object,
            default: () => ({}),
        },
        /**
         * Listing item props
         */
        itemProps: {
            type: Object,
            default: () => ({}),
        },
        stockAggregatorBannerData: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        showStockAggregatorBanner() {
            return this.stockAggregatorBannerData && !isEmpty(this.stockAggregatorBannerData);
        },
    },
    methods: {
        onBannerClick(payload = {}, position) {
            /**
             * Emits a new event when the stck aggregator banner is clicked
             */
            this.$emit('banner-click', { ...payload, position });
        },
    },
};
</script>
